import { useEffect, useMemo, useState } from "react";
import {
  getLatestUserStatements,
  getLatestSignedStatements,
} from "../../api/statements";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { MantineReactTable } from "mantine-react-table";

const LatestStatements = ({ type }) => {
  const { getAccessTokenSilently } = useAuth0();
  const navigate = useNavigate();

  const [statements, setStatements] = useState([]);

  const getStatements = async (token) => {
    if (type === "new") {
      setStatements(await getLatestUserStatements(token));
    } else {
      setStatements(await getLatestSignedStatements(token));
    }
  };

  useEffect(() => {
    async function getToken() {
      const token = await getAccessTokenSilently();
      getStatements(token);
    }
    getToken();
  }, [getAccessTokenSilently]);

  const columns = useMemo(
    () => [
      {
        header: "Ime in priimek",
        accessorKey: "name",
      },
    ],
    []
  );

  return (
    <>
      <MantineReactTable
        columns={columns}
        data={statements}
        mantineTableBodyRowProps={({ row }) => ({
          onClick: () => {
            navigate("/statement-details", { state: row.original });
          },
          sx: {
            cursor: "pointer",
          },
        })}
        //options
        enablePagination={false}
        enableFullScreenToggle={false}
        enableDensityToggle={false}
        enableColumnFilters={false}
        enableHiding={false}
        enableRowSelection={false}
        enableColumnOrdering={false}
        enableGlobalFilter={false}
      />
    </>
  );
};

export default LatestStatements;
